import { __t, applyTranslations } from 'utils/language';

import type { TutorialCarouselSlide } from 'components/tutorial-carousel/TutorialCarouselSlide.type';

applyTranslations(require('./i18n/tutorials.i18n.json'));

export function getInfluencerTutorialSlides(endDate): Array<TutorialCarouselSlide> {
  return [
    {
      type: 'generic',
      key: 'influencer-generic-1',
      title: __t('tutorials.influencer_generic_slide_1_title'),
      body: __t('tutorials.influencer_generic_slide_1_body'),
      imageName: 'tutorial-carousel-introduce-yourself',
      qa: 'tutorial-carousel-slide-1',
      overrides: {
        imageSize: 'normal'
      },
      extras: {
        date: ''
      },
      iconName: ''
    },
    {
      type: 'generic',
      key: 'influencer-generic-2',
      title: __t('tutorials.influencer_generic_slide_2_title'),
      body: __t('tutorials.influencer_generic_slide_2_body'),
      imageName: 'tutorial-carousel-produce-content',
      qa: 'tutorial-carousel-slide-2',
      extras: {
        date: ''
      },
      overrides: {
        imageSize: 'normal'
      },
      iconName: ''
    },
    {
      type: 'generic',
      key: 'influencer-generic-3',
      title: __t('tutorials.influencer_generic_slide_3_title'),
      body: __t('tutorials.influencer_generic_slide_3_body'),
      imageName: 'tutorial-carousel-show-your-work',
      qa: 'tutorial-carousel-slide-3',
      overrides: {
        imageSize: 'normal'
      },
      extras: {
        date: ''
      },
      iconName: ''
    },
    {
      type: 'generic',
      key: 'influencer-generic-4',
      title: __t('tutorials.influencer_generic_slide_4_title'),
      body: __t('tutorials.influencer_generic_slide_4_body'),
      imageName: 'tutorial-carousel-get-paid',
      qa: 'tutorial-carousel-slide-4',
      overrides: {
        imageSize: 'small'
      },
      extras: {
        date: '',
        slideModificator: 'get-paid'
      },
      iconName: ''
    },
    {
      type: 'custom',
      key: 'influencer-custom-end',
      body: __t('tutorials.influencer_custom_end_body'),
      iconName: 'okay-gesture',
      qa: 'tutorial-carousel-slide-5',
      overrides: {
        imageSize: 'small'
      },
      extras: {
        date: endDate
      },
      title: '',
      imageName: ''
    }
  ];
}

export function getBrandTutorialSlides() {
  return [
    {
      type: 'generic',
      key: 'brand-generic-1',
      title: __t('tutorials.brand_generic_slide_1_title'),
      body: __t('tutorials.brand_generic_slide_1_body'),
      imageName: 'tutorial-carousel-create-campaign-brief',
      qa: 'tutorial-carousel-slide-1',
      overrides: {
        imageSize: 'normal'
      }
    },
    {
      type: 'generic',
      key: 'brand-generic-2',
      title: __t('tutorials.brand_generic_slide_2_title'),
      body: __t('tutorials.brand_generic_slide_2_body'),
      imageName: 'tutorial-carousel-search-content-creators',
      qa: 'tutorial-carousel-slide-2',
      overrides: {
        imageSize: 'normal'
      }
    },
    {
      type: 'generic',
      key: 'brand-generic-3',
      title: __t('tutorials.brand_generic_slide_3_title'),
      body: __t('tutorials.brand_generic_slide_3_body'),
      imageName: 'tutorial-carousel-add-to-shortlist',
      qa: 'tutorial-carousel-slide-3',
      overrides: {
        imageSize: 'normal'
      }
    },
    {
      type: 'generic',
      key: 'brand-generic-4',
      title: __t('tutorials.brand_generic_slide_4_title'),
      body: __t('tutorials.brand_generic_slide_4_body'),
      imageName: 'tutorial-carousel-individual-offer',
      qa: 'tutorial-carousel-slide-4',
      overrides: {
        imageSize: 'normal'
      }
    },
    {
      type: 'generic',
      key: 'brand-generic-5',
      title: __t('tutorials.brand_generic_slide_5_title'),
      body: __t('tutorials.brand_generic_slide_5_body'),
      imageName: 'tutorial-carousel-chat-with-creators',
      qa: 'tutorial-carousel-slide-5'
    },
    {
      type: 'generic',
      key: 'brand-generic-6',
      title: __t('tutorials.brand_generic_slide_6_title'),
      body: __t('tutorials.brand_generic_slide_6_body'),
      imageName: 'tutorial-carousel-reporting',
      qa: 'tutorial-carousel-slide-6'
    },
    {
      type: 'generic',
      key: 'brand-generic-7',
      title: __t('tutorials.brand_generic_slide_7_title'),
      body: __t('tutorials.brand_generic_slide_7_body'),
      imageName: 'tutorial-carousel-invoice',
      qa: 'tutorial-carousel-slide-7',
      overrides: {
        imageSize: 'small'
      }
    },
    {
      type: 'custom',
      key: 'brand-custom-end',
      body: __t('tutorials.brand_custom_end_body'),
      iconName: 'okay-gesture',
      qa: 'tutorial-carousel-slide-8'
    }
  ];
}
